<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(-568 -271)">
      <path
        d="M3.765,4.5h12.2a.568.568,0,0,1,.419.951l-4.664,5.133a.553.553,0,0,0-.149.384v4.018a.561.561,0,0,1-.255.476L9.04,16.975a.568.568,0,0,1-.881-.469V10.968a.554.554,0,0,0-.149-.384L3.345,5.451a.568.568,0,0,1,.42-.951h0Z"
        transform="translate(566.136 268.5)"
        fill="none"
        stroke="#74788d"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconFilter',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>